import { useParams } from "react-router-dom";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { InfraLayout } from '../InfraLayout';
import { InfraRouterProps } from "../InfraRouterProps";
import EnvironmentList from "../components/EnvironmentList";

export interface EnvironmentSelectPageProps extends NSARouterMakerResult, InfraRouterProps { }

function EnvironmentSelectPage(props: EnvironmentSelectPageProps)
{
    let params = useParams();
    let project_id = params["project-id"];

    return (
        <InfraLayout
            {...props}
            action={{
                title: "Select Environment"
            }}
        >
            <>
                {
                    project_id &&
                    <EnvironmentList {...props} project_id={project_id} />
                }
            </>
        </InfraLayout>
    );
}

export default EnvironmentSelectPage;